import check_example from "./../../assets/images/check_example.png";

export const achEnrollFormArr = [
  {
    field: "LENDER ACH DIRECT DEPOSIT FORM",
    arr: [
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="">
                  Money is transferred from one bank account to another by
                  Electronic Funds Transfer (EFT) utilizing the Automated
                  Clearing House (ACH) Network governed by the Federal Reserve
                  System and the National Automated Clearing House Association
                  (NACHA).
                </p>
                <p className="mt-3">
                  Loan payments due to investor/lenders are directly deposited
                  into any personally identifiable bank account. You will
                  receive an email notification as well as itemization of the
                  deposit on your monthly statement.
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "Lender Information:",
        arr: [
          {
            title: "Lender Account #",
            field: "lenderAccountNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Address",
            field: "lenderAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "City",
            field: "lenderCity",
            type: "text",
            className: "col-6",
          },
          {
            title: "State",
            field: "lenderState",
            type: "text",
            className: "col-3",
          },
          {
            title: "Zip Code",
            field: "lenderZipCode",
            type: "text",
            className: "col-3",
          },
          {
            title: "Email",
            field: "lenderEmail",
            type: "email",
            className: "col-6",
          },
          {
            title: "Phone Number",
            field: "lenderPhoneNumber",
            type: "phoneNumber",
            className: "col-6",
          },
        ],
      },
      {
        section:
          "Banking Account Information (Bank accounts must be titled exactly as your account with SLS.)",
        arr: [
          {
            title: "Account Name(s)",
            field: "bankInfo_AccountNames",
            type: "text",
            className: "col-12",
          },
          {
            title: "Bank Name",
            field: "bankInfo_BankName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Account Type",
            field: "accountType",
            type: "radio",
            options: [
              { value: "checking", title: "Checking" },
              { value: "savings", title: "Savings" },
            ],
            className: "col-12",
          },
          {
            title: "Bank Address",
            field: "bankInfo_BankAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "City",
            field: "bankInfo_BankCity",
            type: "text",
            className: "col-6",
          },
          {
            title: "State",
            field: "bankInfo_BankState",
            type: "text",
            className: "col-3",
          },
          {
            title: "Zip Code",
            field: "bankInfo_BankZipCode",
            type: "text",
            className: "col-3",
          },
          {
            title: "Routing Number",
            field: "bankInfo_RoutingNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Account Number",
            field: "bankInfo_AccountNumber",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="">
                  These numbers are located on the bottom of your check as
                  follows:
                </p>
                <img
                  width="700"
                  src={check_example}
                  alt="The lower-left  of a bank check, indicating the routing number is typically found on the bottom left and the account number on the bottom center. "
                />
                <p>
                  I(We) authorize SLS to initiate ACH transactions to my/our
                  account indicated in accordance with the provisions of U.S.
                  law and understand if this payment is returned due to
                  Insufficent Funds (NSF) or an invalid Checking Account #, I
                  (we) are subject to a $45 NSF Fee.:
                </p>
              </>
            ),
          },
          {
            title: "Signature",
            field: "bankInfo_Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Signature",
            field: "bankInfo2_Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "bankInfo_PrintName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "bankInfo_PrintName2",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="fw-bold">
                  Please complete this form and <u>SUBMIT A VOIDED CHECK</u> and
                  email to <a href="mailto:lss@slsbox.com ">lss@slsbox.com</a>.
                </p>
                <p>
                  You will continue to receive checks during the set up process.
                  An email confirmation will be sent when your 1st ACH deposit
                  has been processed.
                </p>
              </>
            ),
          },
        ],
      },
    ],
  },
];

export const additionalLenderForm = [
  {
    field: "general",
    arr: [
      {
        section: "Lender Information (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 2 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested2",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 3 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested3",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 4 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested4",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 5 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested5",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            content: (
              <p className="text-center">
                7525 Topanga Canyon Blvd. Canoga Park, CA 91303 ◼ 8920 W. Tropicana Ave. Ste. 103 Las Vegas, <br></br> NV 89147
                Customer Service: Ph: 818-483-0027 ◼ Fax: 818-876-0337 ◼ info@superiorloanservicing.com<br></br>
                DRE No.: 01878271 ◼ NMLS No.: 235487<br></br>
                www.superiorloanservicing.com 
              </p>
            ),
            type: "content",
            className: "col-12",
          },
        ],
      },
    ],
  },
];

export const lenderDemandRequestForm = [
  {
    field: "general",
    arr: [
      {
        section: "Demand Request Form",
        arr: [
          {
            title: "Loan No.",
            field: "demandRequestForm_LoanNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower",
            field: "demandRequestForm_Borrower",
            type: "text",
            className: "col-6",
          },
          {
            title: "Property",
            field: "demandRequestForm_Property",
            type: "text",
            className: "col-6",
          },
          {
            title: "Company Requesting",
            field: "demandRequestForm_CompanyRequesting",
            type: "text",
            className: "col-6",
          },
          {
            title: "Title Company",
            field: "demandRequestForm_TitleCompany",
            type: "text",
            className: "col-6",
          },
          {
            title: "File No.",
            field: "demandRequestForm_FileNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Person Requesting",
            field: "demandRequestForm_PersonRequesting",
            type: "text",
            className: "col-6",
          },
          {
            title: "Escrow Company",
            field: "demandRequestForm_EscrowCompany",
            type: "text",
            className: "col-6",
          },
          {
            title: "Escrow Officier",
            field: "demandRequestForm_EscrowOfficier",
            type: "text",
            className: "col-6",
          },
          {
            title: "Escrow No.",
            field: "demandRequestForm_EscrowNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Estimated Closing Date",
            field: "demandRequestForm_EstClosingDate",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-6 d-flex align-items-center",
            content: (
              <>
                <p>
                  (Good through date of Demand, not to exceed 30 days)
                </p>
              </>
            ),
          },
          {
            title: "Email Demand To",
            field: "demandRequestForm_EmailDemandTo",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-3 d-flex align-items-center",
            content: (
              <>
                <p className="fw-bold">
                  $30 Demand Fee
                </p>
              </>
            ),
          },
          {
            title: "Additional $75 for RUSH Demand Request",
            field: "slsHeldFunds_InterestReserves",
            type: "checkbox",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12 px-5",
            content: (
              <>
                <p className="fw-bold">
                  All requests for demand must include a form of authorization
                  from the requesting Escrow and/or Title Company signed by the
                  borrower.
                </p>
                <p className="fw-bold">
                  SLS Demand Request form must be signed by the requesting
                  Escrow and/or Title Company. Please forward demand request to{" "}
                  <a href="mailto:demands@slsbox.com">demands@slsbox.com</a>.
                </p>
                <p className="fw-bold">
                  Superior Loan Servicing as agent for the beneficiary will
                  reconvey/release/discharge the lien upon receipt of payment in
                  full.{" "}
                  <span className="text-decoration-underline">
                    All funds must be made payable to Superior Loan Servicing.
                  </span>
                </p>
                <p>
                  By signing below I understand that by requesting a demand from
                  Superior Loan Servicing you hereby acknowledge that Superior
                  Loan Servicing, a loan servicer licensed in the State of
                  California through the California Bureau of Real Estate is the
                  authorized agent for the Beneficiary as per our servicing
                  agreement. All funds for payoff are to be made payable to
                  Superior Loan Servicing. Any use of the demand issued by
                  Superior Loan Servicing to pay to any other payee other than
                  Superior Loan Servicing is a violation of this agreement and
                  will be subject to legal recourse.
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            title: "Signature",
            field: "demandRequestForm_Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name/Title",
            field: "demandRequestForm_PrintNameTitle",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12 px-5",
            content: (
              <>
                <p className="fw-bold">
                ****NOTE: This is NOT a Borrowers Authorization. Borrowers Authorization must be
                provided from requesting company. 
                </p>
              </>
            ),
          },
        ],
      },
    ],
  },
];

export const borrower3rdArr = [
  {
    field: "LENDER 3RD PARTY AUTHORIZATION FORM",
    arr: [
      {
        section: "",
        className: "col-12",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                This Lender Authorization Form will allow Superior Loan
                Servicing or its authorized representatives to share information
                about your account with third parties.
              </p>
            ),
          },
        ],
      },
      {
        section: "Lender Information",
        className: "col-12",
        arr: [
          {
            title: "Date",
            field: "date",
            type: "date",
            className: "col-6",
          },
          {
            title: "Lender Name",
            field: "lenderName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan ID Number",
            field: "loanIdNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower’s Name(s)",
            field: "borrowerName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Subject Property Address",
            field: "subjectPropertyAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                The undersigned Lender(s), authorize Superior Loan Servicing and
                its authorized representatives to release, furnish, provide,
                exchange, and request information related to my/our account to:
              </p>
            ),
          },
        ],
      },
      {
        section: "Authorized Third Party/Parties Contact Information",
        className: "col-12",
        arr: [
          {
            title: "Name",
            field: "thirdPartyName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name",
            field: "thirdPartyName2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Address",
            field: "thirdPartyAddress",
            type: "textarea",
            className: "col-6",
          },
          {
            title: "Address",
            field: "thirdPartyAddress2",
            type: "textarea",
            className: "col-6",
          },
          {
            title: "Phone Number",
            field: "thirdPartyPhoneNumber",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Phone Number",
            field: "thirdPartyPhoneNumber2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email Address",
            field: "thirdPartyEmailAddress",
            type: "email",
            className: "col-6",
          },
          {
            title: "Email Address",
            field: "thirdPartyEmailAddress2",
            type: "email",
            className: "col-6",
          },
          {
            title:
              "I authorize the 3rd party listed above to make payments on my behalf.",
            field: "authorizePayments",
            type: "checkbox",
            className: "col-6",
          },
          {
            title:
              "I authorize the 3rd party listed above to make decisions on loan extensions/modifications.",
            field: "authorizePayments2",
            type: "checkbox",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <p className="fw-bold">Expiration of Authorization</p>
                <p>
                  If applicable, please specify a period of time or the
                  particular transaction for which the authorization is valid.
                  If no expiration date or operational transaction is provided,
                  this authorization will remain valid until revoked in writing.
                </p>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: <label> Enter Date of Expiration (if applicable):</label>,
          },
          {
            title: "Date of Expiration",
            field: "authorizationExpiration",
            type: "date",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <u>
                  You may revoke this authorization at any time by providing
                  written notice to Superior Loan Servicing.
                </u>
                <p>
                  I/We hereby indemnify and forever hold Superior Loan Servicing
                  harmless from any and all actions and causes of actions,
                  suits, claims, attorney’s fees, or demands against Superior
                  Loan Servicing, which I/we and/or my/our heirs may have
                  resulting from Superior Loan Servicing discussing, or
                  declining to discuss, my/our account with the above-named
                  requestor or person identifying himself/herself to be that
                  requestor, or resulting from providing, or declining to
                  provide, any documents or other information concerning the
                  account to the requestor.
                </p>
              </div>
            ),
          },
          {
            title: "Signature",
            field: "lenderSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Signature",
            field: "lender2Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "lenderPrintName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "lender2PrintName",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                Please complete this form and return it by mail or email to
                <a href="mailto:lss@slsbox.com"> lss@slsbox.com</a>
              </p>
            ),
          },
        ],
      },
    ],
  },
];
